import loc, { format } from 'owa-localize';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { lazyShowRevocationModal } from 'owa-mail-revocation';
import { RevokeExpirePermissions } from 'owa-mail-revocation/lib/store/schema/OmeMessageState';
import Message from 'owa-service/lib/contract/Message';
import {
    InfoBarMessageColor,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
    InfoBarCustomAction,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import {
    revokeAccess,
    infoDNF,
    revokeSuccessful,
    revokeFailed,
    revokePartialFailed,
    infoRevoked,
    revokeDisplay,
    revokeAriaAnnouncement,
} from './createRevocationInfoBarMessage.locstring.json';
import { OmeMessageResponseStatus } from 'owa-mail-revocation/lib/store/schema/OmeMessageState';
import {
    ENCRYPT_GUID,
    ENCRYPT_DNF_GUID,
} from 'owa-mail-protection/lib/store/schema/rms/EncryptionGUID';
import { rpEncryptMessage } from './createIRMInfoBarMessage.locstring.json';

export default function tryCreateRevocationInfoBarMessage(
    message: Message,
    key: string,
    itemViewState: ItemViewState
): InfoBarMessageViewState {
    if (itemViewState?.omeMessageState && message && message.RightsManagementLicenseData) {
        const { permissions, revoked } = itemViewState.omeMessageState;
        if (permissions !== RevokeExpirePermissions.Revocable) {
            return null;
        }

        let encrptionText: string = getEncryptionText(message);
        let displayText: string = null;
        let customAction: InfoBarCustomAction = null;
        let actionInformation = null;
        let customActionText: string = null;
        let ariaMessage: string = null;

        if (itemViewState.omeMessageState.responseState === OmeMessageResponseStatus.None) {
            if (!revoked) {
                customActionText = loc(revokeAccess);
                customAction = {
                    text: customActionText,
                    action: async () => {
                        const showRevocationModal = await lazyShowRevocationModal.import();
                        showRevocationModal(
                            itemViewState.omeMessageState,
                            message.InternetMessageId
                        );
                    },
                };
                displayText = encrptionText;
            } else {
                actionInformation = loc(infoRevoked);
                displayText = format(loc(revokeDisplay), encrptionText, actionInformation);
            }
            ariaMessage = format(
                loc(revokeAriaAnnouncement),
                encrptionText,
                actionInformation,
                customActionText
            );
        } else {
            // display based on service response
            displayText = getInfobarTextForOmeResponse(itemViewState.omeMessageState.responseState);
            ariaMessage = displayText;
        }

        const infoBarMessageViewState: InfoBarMessageViewState = {
            key: key,
            source: InfoBarMessageSource.ReadingPane,
            rank: InfoBarMessageRank.Encryption,
            color: InfoBarMessageColor.Grey,
            message: ariaMessage,
            messageParts: [displayText, customAction],
        };

        return infoBarMessageViewState;
    }
    return null;
}

function getInfobarTextForOmeResponse(responseState: OmeMessageResponseStatus): string {
    switch (responseState) {
        case OmeMessageResponseStatus.SuccessOrNoChange:
            return loc(revokeSuccessful);
        case OmeMessageResponseStatus.FailedOrMessageNotFound:
            return loc(revokeFailed);
        case OmeMessageResponseStatus.PartialFailed:
            return loc(revokePartialFailed);
    }
    return null;
}

function getEncryptionText(message: Message): string {
    const IRMData = message.RightsManagementLicenseData;

    if (IRMData.RmsTemplateId == ENCRYPT_GUID) {
        return loc(rpEncryptMessage);
    }

    if (IRMData.RmsTemplateId == ENCRYPT_DNF_GUID) {
        return loc(infoDNF);
    }
    return null;
}
